// removed by extract-text-webpack-plugin
module.exports = {"header":"header_header_3OfLz","headerOpt":"header_headerOpt_19fzy","header_main":"header_header_main_29b6Y","header_title":"header_header_title_2CPHC","logo":"header_logo_3VmQa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/header.css
// module id = 342
// module chunks = 0